import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import useUiStore, { uiStore } from './../../modules/datastores/useUiStore';

/**
 * Global Component to Show Feedback Messages (Success & Errors)
 */
const Feedback: React.FC = () => {
  const uiState = useUiStore();

  return (
    <>
      {uiState.success_message && (
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          open
          autoHideDuration={10000}
          onClose={() => uiStore.clearSuccessMessage()}
          className="alert-success"
        >
          <Alert onClose={() => uiStore.clearSuccessMessage()} severity="success">
            {uiState.success_message}
          </Alert>
        </Snackbar>
      )}
      {uiState.error_message && (
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          open
          autoHideDuration={10000}
          onClose={() => uiStore.clearErrorMessage()}
          className="alert-error"
        >
          <Alert onClose={() => uiStore.clearErrorMessage()} severity="error">
            {uiState.error_message}
          </Alert>
        </Snackbar>
      )}
      {uiState.info_message && (
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          open
          autoHideDuration={10000}
          onClose={() => uiStore.clearInfoMessage()}
          className="alert-info"
        >
          <Alert onClose={() => uiStore.clearErrorMessage()} severity="info">
            {uiState.info_message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};

export default Feedback;
